// Custom Search 3

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length === 1 && mutation.addedNodes[0].classList?.contains("instant-search-menu")) {
              debounce(handleCPSearch3, 300)()
          }
      }
    });

    const config = {
        childList: true,
        subtree: true
    };
    const targetNode = document.body;
    observer.observe(targetNode, config);
})

function handleCPSearch3() {
    $("dd[data-id]").each((ind, item) => {
        let proId = $(item).attr("data-id")
        if (proId) {
            let priceNewEle = $(item).find(".price.cs-has-list-price, .price:not(.cs-has-list-price, .cs-list-price)");
            priceNewEle.attr("bss-b2b-product-id", proId)
            priceNewEle.attr("bss-b2b-product-price", 'true')
        }
    })
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
    let check = false;
    const loop = setInterval(() => {
        $("dd[data-id]").each((ind, item) => {
            let priceOldEle = $(item).find(".price.cs-list-price");
            let priceNewEle = $(item).find(".bss-b2b-customized-original-price").eq(0);
            if (priceOldEle?.length && priceNewEle?.length) {
                priceNewEle.before(priceOldEle);
                check = true;
            }
        });
        if (loop && check) {
            clearInterval(loop)
        }
    }, 100)
    setTimeout(() => {
        clearInterval(loop);
    }, 5000)
}

function debounce(functionRun, delayTime) {
    let functionTimeout;

    return function() {
        const args = arguments;
        const context = this;

        if (functionTimeout) clearTimeout(functionTimeout);

        functionTimeout = setTimeout(() => {
            functionRun.apply(context, args);
        }, delayTime);
    };
}

// End custom search 3
function checkout() {
    const checkoutBtn = document.querySelector('button[name="checkout"], #checkout, .checkout-btn , .bss-b2b-customer-portal-nt-checkout-btn');
    if (checkoutBtn) {
        checkoutBtn.addEventListener("click", (e) => {
            if (checkoutBtn.disabled) {
                e.preventDefault();
                return false;
            }
            // Khóa nút lại
            checkoutBtn.disabled = true;
            checkoutBtn.style.opacity = "0.6";
            checkoutBtn.style.cursor = "not-allowed";
            checkoutBtn.classList.add('bss-disable')
            // Nếu cần submit form hoặc chuyển trang
            setTimeout(() => {
                checkoutBtn.disabled = false;
                checkoutBtn.style.opacity = "1";
                checkoutBtn.style.cursor = "pointer";
                checkoutBtn.style.pointerEvents = "auto"; // chặn mọi click
                checkoutBtn.classList.remove('bss-disable')
            }, 5000); // sau 5s mới cho bấm lại
        });
    }
}

setTimeout(()=>{
  const observer = new MutationObserver((MutationList) => {
    // console.log(MutationList)
    for(let item of MutationList){
      if(item.target.className === 't4s-modal__content'){
        // console.log(123);
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
      }
      // if(item.target.childNodes[0].className === 'instant-search-menu cloud-search-results'){
      //   console.log(123);
      // }
    }
  })
  observer.observe(document.body, {childList: true, subtree:true})
}, 300)

document.addEventListener("DOMContentLoaded", function () {
  let typingTimer;
  let doneTypingInterval = 1500;
  console.log($(".t4s-search-form__input.js_iput_search.col"))
  $(".t4s-search-form__input.js_iput_search.col").on('input', function() {
    console.log(123);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  });

  function doneTyping() {
    //after typing-
    console.log($('.results-block block-products dl dd'))
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false) 
  }
    checkout()
let searchDrawer = document.querySelector('.t4s-cartPage__items');

if (searchDrawer) {
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {

            if (m.addedNodes.length) {

                // Lấy lại danh sách nút checkout sau mỗi thay đổi
                let buttons = document.querySelectorAll(
                  'button[name="checkout"], #checkout, .checkout-btn, .bss-b2b-customer-portal-nt-checkout-btn'
                );

                // Khóa nút khi cart render
                buttons.forEach(btn => {
                    btn.style.pointerEvents = "none";
                });


                // Fix giá sau khi cart load
                BSS_B2B.cart.fixer(BSS_B2B.shopData, true, true);

                // Mở khóa sau 2 giây
                setTimeout(() => {

                    // Query lại vì DOM có thể đổi
                    let updatedButtons = document.querySelectorAll(
                      'button[name="checkout"], #checkout, .checkout-btn, .bss-b2b-customer-portal-nt-checkout-btn'
                    );

                    updatedButtons.forEach(btn => {
                      console.log('test')
                        btn.style.pointerEvents = "auto";
                    });

                }, 2000);
            }
        });
    });

    observer.observe(searchDrawer, { childList: true });
}


});

$(document).ready(function() {
  try {
    const scripts = document.head.querySelectorAll('script[data-src^="https://cdn.shopify.com/extensions/"][data-src*="bss-b2b"]')
    if (scripts?.length) {
      scripts.forEach(script => {
        script.defer = true;
        script.src = script.getAttribute("data-src");
      })
    }
  } catch (e) {
    console.error("bss-custom.js", e);
  } 
  $('.search-form').on('submit', function(event) {
    // Get the current action attribute
    var formAction = $(this).attr('action');

    // If the action contains '/a/search', replace it with '/search'
    if (formAction.includes('/a/search')) {
      $(this).attr('action', formAction.replace('/a/search', '/search'));
    }
  });
});

window.onload = function(){
  if(window.location.pathname.includes("/products/")) {
    let checkOnTop = false;
    function autoScrollToTop() {
      if (window.scrollY !== 0) {
          document.querySelector('html').scrollIntoView({
              behavior: 'smooth',
              block: 'start'
          })
      } else {
        window.scrollBy(0, 1);
        document.querySelector('html').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
      }
    }
    autoScrollToTop();
  }
}
